export const CANNOT_GET_CREDENTIALS = "cannot_get_credentials";
export const CANNOT_CONNECT = "cannot_connect";
export const CANNOT_ACCESS_DEVICES = "cannot_access_devices";
export const CANNOT_PUBLISH = "cannot_publish";
export const NEED_PERMISSION_PROMPT = "need_permission_prompt";
export const NEED_PERMISSION_SCREEN = "need_permission_screen";
